import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {PlanService} from '../../../services/plan.service';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {Observable, of} from 'rxjs';
import * as featureActions from '../../index';
import {catchError, combineLatest, map, mergeMap, switchMap, withLatestFrom} from 'rxjs/operators';
import { PriceActions } from '../actions/price.actions';



@Injectable()
export class PriceEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private planService = inject(PlanService);

  constructor() {}

  ReadPriceList$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.PriceActionTypes.LoadPrices),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const param = {
        otp: user.otp
      };
      return this.planService.ReadPriceList(param).pipe(
        map((res: any) => {
          if (res.result) {
            return new featureActions.UpsertPrices(res.msg.body);
          } else {
            return new featureActions.GetPricesFails();
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.GetPricesFails());
        })
      );
    })
  ));
}
